import React, { useEffect, useState } from 'react'
import api from '../../api';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { MapPin, Building, Home } from 'lucide-react';

function Section_5() {
    const userID = sessionStorage.getItem("RoleCode");
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false);
    const [taluk, setTaluk] = useState("");
    const [village, setVillage] = useState("");
    const [villages, setVillages] = useState([]);
    const [filteredData, setFilteredData] = useState(null);

    const district = "Chitradurga District";
    const districtData = {
        "Chitradurga District": {
            "Chitradurga": [
                "Jodichikkenahalli",
                "Kyadigere",
                "Hale Dyamavvana Halli",
                "J J Hatti",
                "Kasavanahalli",
                "Ennegere",
                "Gonur",
                "Venkateshwara Badavane",
                "Gandhi Nagara",
                "Kasavarahatti"
            ],
            "Hiriyur": [
                "Hosakere",
                "Halagaladdi",
                "Khandenahalli Palya",
                "Benakanahalli",
                "P D Kote",
                "Adivala Farm",
                "T G Colony",
                "Bovi Colony",
                "Adivala",
                "Gollarahatti"
            ],
            "Holalkere": [
                "Kolalu",
                "Echaghatta",
                "T-Nulenuru",
                "Kereyagalahalli",
                "Halenahalli",
                "Hulikere",
                "Kudineer Katte",
                "Talya",
                "Tekalarvatti",
                "Holalkere_Gollarahatti"
            ]
        }
    };

    useEffect(() => {
        if (taluk) {
            setVillages(districtData[district][taluk] || []);
            setVillage("");
        } else {
            setVillages([]);
            setVillage("");
        }
    }, [taluk]);

    // Filter data based on selected taluk and village
    useEffect(() => {
        if (!data) return;

        const filterDataByLocation = (items, taluk, village) => {
            if (!Array.isArray(items)) return items;

            return items.filter(item => {
                const itemTaluk = item.taluk_name || item.fld_taluk_name;
                const itemVillage = item.village_name || item.fld_village_name;

                const talukMatch = !taluk || itemTaluk === taluk;
                const villageMatch = !village || itemVillage === village;

                return talukMatch && villageMatch;
            });
        };

        const filtered = JSON.parse(JSON.stringify(data));

        // Recursively filter all arrays in the data structure
        const filterNestedData = (obj) => {
            if (Array.isArray(obj)) {
                return filterDataByLocation(obj, taluk, village);
            } else if (obj && typeof obj === 'object') {
                const result = {};
                for (const key in obj) {
                    result[key] = filterNestedData(obj[key]);
                }
                return result;
            }
            return obj;
        };

        setFilteredData(filterNestedData(filtered));
    }, [data, taluk, village]);

    const rawData = async () => {
        setLoading(true)
        try {
            const requestData = {
                login_user_id: userID,
                synceddatetime: "2023-01-24 11:57:34",
                FormCode: "314",
                ApiKey: "kavin",
                AppTypeNo: "3",
                AppVersion: "1.0.0"
            };
            const url = 'section_5_dashboard'
            const result = await api.get_Dashboard_Section(url, requestData);
            setData(result.responsemessage.household_dashboard_5)
        } catch (error) {
            console.error("Error fetching requested data:", error);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        rawData();
    }, []);

  const DashboardCards = () => {
    if (!filteredData) return null;

    // Function to extract relevant fields from data items - COMPREHENSIVE FIX
    const extractDataFields = (items, subCategory) => {
        if (!items || items.length === 0) return null;

        const firstItem = items[0];
        
        // Log available fields for debugging
        console.log(`Fields for ${subCategory}:`, Object.keys(firstItem));

        // Find count field - comprehensive pattern matching
        const countField = Object.keys(firstItem).find(key => {
            const lowerKey = key.toLowerCase();
            return (
                // General count patterns
                lowerKey.startsWith('count_') ||
                lowerKey.endsWith('_count') ||
                
                // Specific NCD patterns
                lowerKey.includes('count_fa_ho_choronic_dis_diabetes') ||
                lowerKey.includes('no_of_person_') ||
                
                // Maternal Health patterns
                lowerKey.includes('count_currently_pregnant_women') ||
                lowerKey.includes('count_currently_not_pregnant_women') ||
                lowerKey.includes('count_preg_rel_pres_past_cesarian') ||
                lowerKey.includes('count_preg_rel_pres_past_any_others') ||
                
                // Communicable Diseases patterns (add these)
                lowerKey.includes('count_people_with_') ||
                lowerKey.includes('count_household_with_') ||
                lowerKey.includes('count_family_with_') ||
                
                // Other patterns
                lowerKey.includes('bmi_') ||
                lowerKey.includes('birth_weight_') ||
                lowerKey.includes('transport_access_count') ||
                lowerKey.includes('job_security_count') ||
                
                // Fallback: any field with 'count' that's not a percentage/total field
                (lowerKey.includes('count') && 
                 !lowerKey.includes('percentage') && 
                 !lowerKey.includes('taluk') && 
                 !lowerKey.includes('village') &&
                 !lowerKey.includes('grand_total'))
            );
        });

        if (!countField) {
            console.log('No count field found for:', subCategory, 'Available fields:', Object.keys(firstItem));
            return null;
        }

        // Determine data type and name field based on the data structure
        let dataType = 'village_breakdown';
        let nameField = 'fld_village_name';
        let displayName = getDisplayNameFromSubCategory(subCategory);

        // Check if this is category-based data (has status/mode/type fields)
        const categoryField = Object.keys(firstItem).find(key => {
            const lowerKey = key.toLowerCase();
            const excludedFields = ['taluk', 'village', 'id', 'total', 'percentage', 'count', 'fld_', 'sl_no'];
            
            const isExcluded = excludedFields.some(excluded => 
                lowerKey.includes(excluded)
            );
            
            if (isExcluded) return false;
            
            return (
                lowerKey.endsWith('_status') ||
                lowerKey.endsWith('_mode') ||
                lowerKey.endsWith('_type') ||
                lowerKey.includes('transport_access_status') ||
                lowerKey.includes('job_security_status') ||
                (lowerKey.length > 3 && !isExcluded)
            );
        });

        if (categoryField) {
            // This is category-based data (like transportation, job security, etc.)
            dataType = 'category_based';
            nameField = categoryField;
        } else if (countField.includes('no_of_person_')) {
            // Single disease data
            const diseaseMatch = countField.match(/no_of_person_([a-zA-Z_]+)/);
            if (diseaseMatch) {
                dataType = 'single_disease';
                nameField = 'disease_type';
                displayName = diseaseMatch[1].replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            }
        } else if (countField.includes('bmi_')) {
            // BMI data
            const bmiMatch = countField.match(/bmi_([a-zA-Z_]+)_count/);
            if (bmiMatch) {
                dataType = 'single_category';
                nameField = 'bmi_category';
                displayName = bmiMatch[1].replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            }
        }
        // For NCD, Maternal Health, and Communicable Diseases - use village breakdown
        // These will default to dataType: 'village_breakdown'

        return {
            countField,
            nameField,
            dataType,
            displayName
        };
    };

    // Helper function to create readable display names
    const getDisplayNameFromSubCategory = (subCategory) => {
        return subCategory
            .replace(/_/g, ' ')
            .replace(/([A-Z])/g, ' $1')
            .replace(/\b\w/g, l => l.toUpperCase())
            .trim();
    };

    // Function to aggregate data by category name - COMPREHENSIVE
    const aggregateDataByCategory = (items, fieldData) => {
        if (!items || !fieldData || !fieldData.countField) return [];

        const { countField, nameField, dataType } = fieldData;

        switch (dataType) {
            case 'village_breakdown':
                // Village-wise data (NCD, Maternal Health, Communicable Diseases)
                const villageData = {};
                
                items.forEach(item => {
                    const villageName = item[nameField] || item.fld_village_name;
                    const talukName = item.fld_taluk_name;
                    const countValue = parseFloat(item[countField]) || 0;
                    
                    if (villageName) {
                        if (!villageData[villageName]) {
                            villageData[villageName] = {
                                name: villageName,
                                taluk: talukName,
                                count: 0
                            };
                        }
                        villageData[villageName].count += countValue;
                    }
                });

                const villageResult = Object.values(villageData);
                const totalVillageCount = villageResult.reduce((sum, item) => sum + item.count, 0);

                villageResult.forEach(item => {
                    item.percentage = totalVillageCount > 0 ? (item.count / totalVillageCount) * 100 : 0;
                });

                villageResult.sort((a, b) => b.count - a.count);
                return villageResult;

            case 'category_based':
                // Data with categories (transportation, job security, etc.)
                const categoryData = {};
                
                items.forEach(item => {
                    const categoryName = item[nameField];
                    const countValue = parseFloat(item[countField]) || 0;
                    
                    if (categoryName) {
                        if (!categoryData[categoryName]) {
                            categoryData[categoryName] = {
                                name: categoryName,
                                count: 0
                            };
                        }
                        categoryData[categoryName].count += countValue;
                    }
                });

                const categoryResult = Object.values(categoryData);
                const totalCategoryCount = categoryResult.reduce((sum, item) => sum + item.count, 0);

                categoryResult.forEach(item => {
                    item.percentage = totalCategoryCount > 0 ? (item.count / totalCategoryCount) * 100 : 0;
                });

                return categoryResult;

            case 'single_disease':
            case 'single_category':
                // Single category data (BMI, specific diseases, etc.)
                const totalCount = items.reduce((sum, item) => sum + (parseFloat(item[countField]) || 0), 0);
                return [{
                    name: fieldData.displayName,
                    count: totalCount,
                    percentage: 100
                }];

            default:
                console.log('Unknown data type:', dataType);
                return [];
        }
    };

    // Card colors for different categories
    const cardColors = {
        "Communicable Disease": "#10b981",
        "Non Communicable Diseases": "#f97316",
        "Transportation": "#3b82f6",
        "Job Security": "#ef4444",
        "Financial": "#8b5cf6",
        "Maternal And Child Health": "#ec4899",
        "Hypertension": "#dc2626",
        "Diabetes": "#059669",
        "Cardiac Diseases": "#7c3aed",
        "Cancer": "#f59e0b",
        "BMI": "#8b5cf6",
        "Birth Weight": "#06b6d4",
        "Women Health": "#ec4899",
        "Immunisation": "#f59e0b",
        "Nutrition Status": "#84cc16"
    };

    // Render card block function
    const renderCardBlock = (category, subCategory, items, label) => {
        if (!Array.isArray(items) || items.length === 0) {
            console.log(`No items for ${category} - ${subCategory}`);
            return null;
        }

        const fieldData = extractDataFields(items, subCategory);

        if (!fieldData || !fieldData.countField) {
            console.log('Missing count field for:', label, {
                availableFields: items.length > 0 ? Object.keys(items[0]) : 'No items',
                subCategory
            });
            return null;
        }

        // Aggregate data
        const aggregatedItems = aggregateDataByCategory(items, fieldData);

        if (aggregatedItems.length === 0) {
            console.log('No aggregated items for:', label, fieldData);
            return null;
        }

        // Calculate total count from aggregated data
        const totalCount = aggregatedItems.reduce((sum, item) => sum + item.count, 0);

        // Get color based on category
        const cardColor = cardColors[category] || "#4ca8db";

        // Determine display type
        const isVillageBreakdown = fieldData.dataType === 'village_breakdown';
        const isSingleCategory = fieldData.dataType === 'single_disease' || fieldData.dataType === 'single_category';

        return (
            <div className="bar text-600" key={`${category}-${subCategory}`}>
                <div>
                    <div className="flex justify-content-between align-items-center">
                        <p className="w-9 font-semibold">{label}</p>
                        <p className="font-medium">Total - {totalCount}</p>
                    </div>

                    <div className="grid flex align-items-center mb-3 headingCard f12 font-semibold">
                        <div className="col-5">
                            {isVillageBreakdown ? "Village (Taluk)" : 
                             isSingleCategory ? "Category" : "Category"}
                        </div>
                        <div className="col-2 text-center">Count</div>
                        <div className="col-5">Percentage</div>
                    </div>

                    {aggregatedItems.map((item, idx) => (
                        <div className="grid flex align-items-center mt-2 f12" key={idx}>
                            <div className="col-5">
                                {isVillageBreakdown ? (
                                    <div>
                                        <span className="font-medium">{item.name}</span>
                                        {item.taluk && (
                                            <span className="text-xs text-gray-500 ml-1">({item.taluk})</span>
                                        )}
                                    </div>
                                ) : (
                                    <span className="font-medium">{item.name}</span>
                                )}
                            </div>
                            <div className="col-2 text-center">
                                <span>{item.count}</span>
                            </div>
                            <div className="col-5">
                                <div className="flex align-items-center gap-2">
                                    <div
                                        style={{
                                            height: "8px",
                                            backgroundColor: "#e0e0e0",
                                            borderRadius: "10px",
                                            overflow: "hidden",
                                            position: "relative",
                                            flex: 1
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: "100%",
                                                backgroundColor: cardColor,
                                                width: `${parseFloat(item.percentage) || 0}%`,
                                                borderRadius: "10px",
                                                transition: "width 0.3s ease"
                                            }}
                                        />
                                    </div>
                                    <span style={{ minWidth: '45px', fontSize: '11px' }}>
                                        {parseFloat(item.percentage || 0).toFixed(1)}%
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    // Render all categories dynamically
    const renderAllCategories = () => {
        if (!filteredData) return null;

        return Object.keys(filteredData).map(mainCategory => {
            const mainCategoryData = filteredData[mainCategory];
            if (typeof mainCategoryData !== 'object') return null;

            return Object.keys(mainCategoryData).map(subCategory => {
                const items = mainCategoryData[subCategory];
                if (!Array.isArray(items) || items.length === 0) {
                    console.log(`No items for ${mainCategory} - ${subCategory}`);
                    return null;
                }

                // Create a readable label
                const label = subCategory
                    .replace(/_/g, ' ')
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/\b\w/g, l => l.toUpperCase())
                    .trim();

                return (
                    <div key={`${mainCategory}-${subCategory}`} className="mb-4">
                        <div className="font-semibold text-lg mb-2 text-gray-700 border-b pb-1">
                            {mainCategory} - {label}
                        </div>
                        <div className="first-cards">
                            <div className="first-sub">
                                {renderCardBlock(mainCategory, subCategory, items, label)}
                            </div>
                        </div>
                    </div>
                );
            });
        });
    };

    return (
        <div className='render-container'>
            {renderAllCategories()}
        </div>
    );
};
    return (
        <div className='bg-blue-50 min-h-screen'>
            {loading && (
                <div className="backdrop">
                    <ProgressSpinner className='progressBar' />
                </div>
            )}

            {/* Filter Section */}

            <div style={{
                background: 'linear-gradient(to bottom right, #ffffff, #f9fafb)',
                borderRadius: '0.75rem',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                border: '1px solid #e5e7eb',
                overflow: 'hidden',
                marginBottom: '1rem'
            }}>
                {/* <div style={{
                              background: 'linear-gradient(to right, #3b82f6, #2563eb)',
                              padding: '1rem 1.5rem'
                          }}>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                      <div style={{
                                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                          backdropFilter: 'blur(8px)',
                                          borderRadius: '0.5rem',
                                          padding: '0.5rem'
                                      }}>
                                          <Filter style={{ width: '1.25rem', height: '1.25rem', color: 'white' }} />
                                      </div>
                                      <div>
                                          <h2 style={{ color: 'white', fontWeight: 600, fontSize: '1.125rem', margin: 0 }}>Location Filters</h2>
                                          <p style={{ color: '#dbeafe', fontSize: '0.75rem', margin: 0 }}>Select your location hierarchy</p>
                                      </div>
                                  </div>
                                  {activeFiltersCount > 0 && (
                                      <div style={{
                                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                          backdropFilter: 'blur(8px)',
                                          padding: '0.375rem 0.75rem',
                                          borderRadius: '9999px'
                                      }}>
                                          <span style={{ color: 'white', fontSize: '0.875rem', fontWeight: 500 }}>
                                              {activeFiltersCount} {activeFiltersCount === 1 ? 'filter' : 'filters'} active
                                          </span>
                                      </div>
                                  )}
                              </div>
                          </div> */}

                <div style={{ padding: '1.5rem' }}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '1.5rem'
                    }}>
                        <div>
                            <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: '#374151',
                                marginBottom: '0.625rem',
                                fontWeight: 500
                            }}>
                                <div style={{
                                    backgroundColor: '#dbeafe',
                                    padding: '0.375rem',
                                    borderRadius: '0.5rem'
                                }}>
                                    <MapPin style={{ width: '1rem', height: '1rem', color: '#2563eb' }} />
                                </div>
                                <span style={{ fontSize: '0.875rem' }}>District</span>
                            </label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    value={district}
                                    disabled
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 1rem',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '0.5rem',
                                        backgroundColor: '#f9fafb',
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        color: '#4b5563',
                                        cursor: 'not-allowed'
                                    }}
                                />
                                <div style={{
                                    position: 'absolute',
                                    right: '0.75rem',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    backgroundColor: '#e5e7eb',
                                    padding: '0.125rem 0.5rem',
                                    borderRadius: '0.25rem',
                                    fontSize: '0.75rem',
                                    color: '#6b7280'
                                }}>
                                    Fixed
                                </div>
                            </div>
                        </div>

                        <div>
                            <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: '#374151',
                                marginBottom: '0.625rem',
                                fontWeight: 500
                            }}>
                                <div style={{
                                    backgroundColor: '#dcfce7',
                                    padding: '0.375rem',
                                    borderRadius: '0.5rem'
                                }}>
                                    <Building style={{ width: '1rem', height: '1rem', color: '#16a34a' }} />
                                </div>
                                <span style={{ fontSize: '0.875rem' }}>Taluk</span>
                            </label>
                            <div style={{ position: 'relative' }}>
                                <select
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 2.5rem 0.75rem 1rem',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        appearance: 'none',
                                        cursor: 'pointer',
                                        backgroundColor: 'white'
                                    }}
                                    value={taluk}
                                    onChange={(e) => setTaluk(e.target.value)}
                                >
                                    <option value="">All Taluks</option>
                                    {Object.keys(districtData[district] || {}).map((t) => (
                                        <option key={t} value={t}>{t}</option>
                                    ))}
                                </select>
                                <div style={{
                                    position: 'absolute',
                                    right: '0.75rem',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    pointerEvents: 'none'
                                }}>
                                    <svg style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: '#374151',
                                marginBottom: '0.625rem',
                                fontWeight: 500
                            }}>
                                <div style={{
                                    backgroundColor: '#f3e8ff',
                                    padding: '0.375rem',
                                    borderRadius: '0.5rem'
                                }}>
                                    <Home style={{ width: '1rem', height: '1rem', color: '#9333ea' }} />
                                </div>
                                <span style={{ fontSize: '0.875rem' }}>Village</span>
                            </label>
                            <div style={{ position: 'relative' }}>
                                <select
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 2.5rem 0.75rem 1rem',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        appearance: 'none',
                                        cursor: !villages.length ? 'not-allowed' : 'pointer',
                                        backgroundColor: !villages.length ? '#f9fafb' : 'white',
                                        color: !villages.length ? '#9ca3af' : 'inherit'
                                    }}
                                    value={village}
                                    onChange={(e) => setVillage(e.target.value)}
                                    disabled={!villages.length}
                                >
                                    <option value="">All Villages</option>
                                    {villages.map((v) => (
                                        <option key={v} value={v}>{v}</option>
                                    ))}
                                </select>
                                <div style={{
                                    position: 'absolute',
                                    right: '0.75rem',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    pointerEvents: 'none'
                                }}>
                                    <svg style={{ width: '1.25rem', height: '1.25rem', color: '#9ca3af' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        marginTop: '1.5rem',
                        paddingTop: '1.25rem',
                        borderTop: '1px solid #e5e7eb'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <div style={{
                                    width: '0.5rem',
                                    height: '0.5rem',
                                    backgroundColor: '#22c55e',
                                    borderRadius: '9999px',
                                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                                }}></div>
                                <span style={{ fontSize: '0.875rem', color: '#4b5563', fontWeight: 500 }}>Active Selection:</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.875rem', flexWrap: 'wrap' }}>
                                {taluk ? (
                                    <span style={{
                                        backgroundColor: '#dcfce7',
                                        color: '#15803d',
                                        padding: '0.375rem 0.75rem',
                                        borderRadius: '0.5rem',
                                        fontWeight: 500
                                    }}>
                                        📍 {taluk}
                                    </span>
                                ) : (
                                    <span style={{ color: '#9ca3af' }}>No taluk selected</span>
                                )}
                                {village ? (
                                    <span style={{
                                        backgroundColor: '#f3e8ff',
                                        color: '#7e22ce',
                                        padding: '0.375rem 0.75rem',
                                        borderRadius: '0.5rem',
                                        fontWeight: 500
                                    }}>
                                        🏘️ {village}
                                    </span>
                                ) : taluk ? (
                                    <span style={{ color: '#9ca3af' }}>No village selected</span>
                                ) : null}
                                {!taluk && !village && (
                                    <span style={{
                                        color: '#6b7280',
                                        backgroundColor: '#f3f4f6',
                                        padding: '0.375rem 0.75rem',
                                        borderRadius: '0.5rem'
                                    }}>
                                        Showing all data for {district}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Dashboard Content */}
            <div className="gridDashboard pt-3">
                {filteredData && <DashboardCards />}
            </div>
        </div>
    )
}

export default Section_5